/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo, FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSONTyped, FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo';
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo(json)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfo(value)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdExternalInfoToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfo.js.map